import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

export class PlotConfig {
  minX: number;
  maxX: number;
  minY: number;
  maxY: number;
  logY:boolean=false;
  logX:boolean=false;
}

@Component({
  selector: 'app-chart-options',
  templateUrl: './chart-options.component.html',
  styleUrls: ['./chart-options.component.css']
})
export class ChartOptionsComponent {

  @Output() plotConfigChange: EventEmitter<PlotConfig> = new EventEmitter();
  @Input() plotConfig:PlotConfig=new PlotConfig();

  constructor() {}

  valueChange(){
    this.plotConfigChange.emit(this.plotConfig);
  }

}

